<template>
  <div class="room-message">
    <div class="content-header inner">
      <button class="btn" :style="{padding: '8px'}" @click="download" :disabled="!messages.length">ダウンロード</button>
      <button v-if="$store.getters['auth/isAdmin']" class="btn c-btn-danger" @click="invertModalStatus">全削除</button>
    </div>
    <div class="chats" id="chats">
      <RoomMessage v-for="(roomMessage, index) in messages" :key="index" :room-message="roomMessage" />
    </div>

    <div class="submitChat">
      <RoomMessageForm @dispatch-rm="dispatchRm" />
    </div>

    <transition name="fade" v-if="showModal">
      <Modal @close="invertModalStatus">
        <div slot="content">
          <div class="content-header inner">
            <h2 :style="{padding: '0'}">
              <span>ルームメッセージをすべて削除します</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <div class="boxTxt_inner inner">
            全ての方がメッセージを読めなくなります。本当に削除しますか？
          </div>
          <div class="modal-footer">
            <button class="btn c-btn-danger" @click="dispatchRmDelete">削除</button>
            <button class="btn" @click="invertModalStatus">キャンセル</button>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import RoomMessageElement from "../elements/RoomMessage"
import RoomMessageFormElement from "../elements/RoomMessageForm"
import {RoomMessage} from "socket_if"
import Modal from "../elements/Modal"

export default {
  name: "RoomMessageColumn",
  components: {
    RoomMessage: RoomMessageElement,
    RoomMessageForm: RoomMessageFormElement,
    Modal
  },
  data() {
    return {
      hoverFlag: false,
      roomSlug: null,
      targetUser: {},
      showModal: false
    }
  },
  props: {
    roomName: {
      type: String,
      required: true
    }
  },
  computed: {
    messages() {
      return this.$store.getters["roomMessages/getBySlugs"](this.$route.params.hallSlug, this.roomSlug ?? null)
    }
  },
  watch: {
    /**
     * computedのmessagesを監視
     */
    messages() {
      this.scrollToEnd()
    }
  },
  created() {
    this.setRoomSlug()
  },
  methods: {
    setRoomSlug() {
      if (this.$route.name === "HRoom") {
        this.roomSlug = this.$route.name
      } else {
        this.roomSlug = this.$route.params.roomSlug
      }
    },
    multipleMethod(targetUserId) {
      this.setTargetUser(targetUserId)
    },
    mouseOverAction() {
      this.hoverFlag = true
    },
    mouseLeaveAction() {
      this.hoverFlag = false
    },
    dispatchRm(message) {
      this.$socket.dispatcher.sendRoomMessage(
        new RoomMessage({
          message: message,
          participant_id: this.$store.getters["auth/id"],
          hallSlug: this.$route.params.hallSlug,
          roomSlug: this.roomSlug ?? null,
          createdAt: this.$moment.now().toString()
        })
      )
    },
    dispatchRmDelete() {
      this.$socket.dispatcher.removeRoomMessage(this.messages)
      this.invertModalStatus()
    },
    getDiffFromNow(createdAt) {
      return this.$moment.unix(createdAt / 1000).fromNow()
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const chatLog = document.getElementById("chats")
        if (!chatLog) return

        chatLog.scrollTop = chatLog.scrollHeight
      })
    },
    download() {
      let text = ""
      _.forEach(this.messages, message => {
        let createdAt = this.$moment.unix(message.createdAt / 1000).format("YYYY-MM-DD HH:mm:ss")
        let name = this.$store.getters["participants/getByUserId"](message.participant_id).name
        let comment = message.message

        text += `${createdAt} 【${name}】 ${comment}\n`
      })

      this.$download.exec(`${this.roomName}.txt`, text, "text/plain")
    }
  }
}
</script>
